import * as Yup from 'yup';

// export const validationSchema = yup.object().shape({
//   mobile: yup
//     .string()
//     .transform((value) => {
//       if (!value) return value;
//       return NumberConverter.toEnglishNumber(value);
//     })
//     .matches(
//       /^09\d{9}$/, // الگو برای شماره موبایل
//       'شماره موبایل باید با 09 شروع شده و 11 رقم باشد.'
//     )
//     .required('شماره موبایل الزامی است.'),
// });

export const validationSchemaStepOne = Yup.object({
  fa_name: Yup.string().required('نام فارسی الزامی است'), // Required Persian name
  en_name: Yup.string().required('نام انگلیسی الزامی است'), // Required English name
  category: Yup.string().required('دسته‌بندی الزامی است'), // Required category
});

export const validationSchemaStepThree = Yup.object({
  fa_description: Yup.string().required('توضیح فارسی الزامی است'), // Required Persian name
  en_description: Yup.string().required('توصیح انگلیسی الزامی است'), // Required English name
  description: Yup.string().required('توضیح الزامی است'), // Required category
});
